import script from "./TopNaviationBar.vue?vue&type=script&setup=true&lang=js"
export * from "./TopNaviationBar.vue?vue&type=script&setup=true&lang=js"

import "./TopNaviationBar.vue?vue&type=style&index=0&id=a9476678&scoped=true&lang=css"
import "./TopNaviationBar.vue?vue&type=style&index=1&id=a9476678&lang=css"

import exportComponent from "C:\\Users\\Simeon\\Desktop\\asic-webpack\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-a9476678"]])

export default __exports__